import http from './request'
import { setItem, getItem, getToken, removeItem } from './storage'
import { alert } from './modal'

const h5Api = {
  storage: {
    getItem (key, success, error) {
      getItem(key, success, error)
    },
    setItem (key, value, success, error) {
      setItem(key, value, success, error)
    },
    removeItem (key) {
      return removeItem(key)
    },
    getToken () {
      return getToken()
    }
  },
  request: http,
  modal: {
    alert (options) {
      alert(options)
    }
  },
  route: {
    getCurrentRoute () {
      const path = location.href

      return path
    },
    getReferUrl () {
      const path = window.sessionStorage.getItem('_refer_url_') || ''

      return path
    }
  }
}

export default h5Api



// WEBPACK FOOTER //
// ./src/npm/monitor/platform/h5/index.js